import React from "react";
import {
  FaAward,
  FaUserFriends,
  FaGlobe,
  FaDatabase,
} from "react-icons/fa";
import { MdEngineering } from "react-icons/md";
// import { FaToolbox } from "react-icons/fa6";
import { motion } from "framer-motion";
// import firefighter from "../images/firefighter.jpg"; 
import about1 from "../assets/about1.jpg";

// Animation Variants
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const staggerContainer = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const ServicesSection = () => {
  return (
    <>
      {/* Services Section */}
      <section className="bg-[#f6fdf8] py-16 px-6 md:px-12 xl:px-20">
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">

          {/* Left Image with green overlay */}
          <motion.div
            className="relative overflow-hidden rounded-2xl shadow-lg"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <img
              src={about1}
              alt="Firefighter"
              className="rounded-2xl shadow-lg w-full object-cover transform hover:scale-105 transition-transform duration-500"
            />
            {/* <div className="absolute inset-0 bg-green-700 opacity-20 mix-blend-multiply rounded-2xl pointer-events-none" /> */}
          </motion.div>

          {/* Right Content */}
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {/* Tagline */}
            <motion.p
              variants={fadeUp}
              className="text-green-700 font-semibold uppercase tracking-wider text-lg mb-2"
            >
              What We Do
            </motion.p>

            {/* Title */}
            <motion.h2
              variants={fadeUp}
              className="text-2xl md:text-3xl font-semibold leading-snug text-gray-900 mb-6"
            >
              Integrated Fire Safety & Protection Solutions
            </motion.h2>

            {/* Description */}
            <motion.div
              variants={fadeUp}
              className="text-gray-600 text-md mb-10 text-justify"
            >
              <p>
                At Nohmi Bosai India, we provide world-class fire protection and disaster
                prevention solutions, backed by over 100 years of global expertise. As part of
                Nohmi Bosai Ltd., Japan, we offer a comprehensive range of fire safety equipments designed to perform under pressure. Whether it’s Fire alarm system, clean agent system or advanced fire protection system, every product we offer is rigorously tested and built to battle.
              </p>

              <p className="mt-2">
                Guided by our mission to protect society, we are committed to raising the
                standards of safety, quality, and innovation across India.
              </p>
            </motion.div>

            {/* Services Cards */}

            <motion.div
              variants={staggerContainer}
              className="flex justify-center" 
            >
              <motion.div
                variants={fadeUp}
                className="bg-[#e8f9ef] p-6 rounded-2xl shadow hover:shadow-lg transition 
               flex flex-col justify-between min-h-[200px] 
               w-full md:max-w-[380px]"
              >
                <div>
                  <div className="flex items-center gap-6">
                    <MdEngineering className="text-green-600 text-6xl" />
                    <h3 className="text-2xl font-bold leading-snug">
                      System Design & Engineering
                    </h3>
                  </div>

                  <p className="text-gray-700 text-md leading-relaxed mt-4">
                    Tailored fire protection system design ensuring compliance, safety, and efficiency.
                  </p>
                </div>
              </motion.div>
            </motion.div>


            {/* <motion.div
              variants={staggerContainer}
              className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch"
            > */}
            {/* Card 1 */}
            {/* <motion.div
                variants={fadeUp}
                className="bg-[#e8f9ef] p-4 rounded-2xl shadow hover:shadow-lg transition 
               flex flex-col justify-between h-full min-h-[250px]"
              >
                <div>
                  <MdEngineering className="text-green-600 text-5xl mb-4" />
                  <h3 className="text-xl font-bold mb-3 leading-snug">
                    System Design & Engineering
                  </h3>
                  <p className="text-gray-700 text-base leading-relaxed">
                    Tailored fire protection system design ensuring compliance, safety, and efficiency.
                  </p>
                </div>
              </motion.div> */}

            {/* Card 2 */}
            {/* <motion.div
                variants={fadeUp}
                className="bg-[#e8f9ef] p-4 rounded-2xl shadow hover:shadow-lg transition 
               flex flex-col justify-between h-full min-h-[250px]"
              >
                <div>
                  <FaToolbox className="text-green-600 text-5xl mb-4" />
                  <h3 className="text-xl font-bold mb-3 leading-snug">
                    Installation & Maintenance
                  </h3>
                  <p className="text-gray-700 text-base leading-relaxed">
                    End-to-end support including installation, commissioning, and reliable long-term maintenance services.
                  </p>
                </div>
              </motion.div>
            </motion.div> */}
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-[#f0fbf4] py-12">
        <motion.div
          className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 text-center divide-y sm:divide-y-0 sm:divide-x divide-gray-200"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {[
            {
              id: 1,
              icon: <FaAward className="text-green-600 text-4xl mb-3" />,
              value: "18+",
              label: "Years Of Expertise",
            },
            {
              id: 2,
              icon: <FaUserFriends className="text-green-600 text-4xl mb-3" />,
              value: "500+",
              label: "Clients Served",
            },
            {
              id: 3,
              icon: <FaGlobe className="text-green-600 text-4xl mb-3" />,
              value: "15+",
              label: "Facilities Covered",
            },
            {
              id: 4,
              icon: <FaDatabase className="text-green-600 text-4xl mb-3" />,
              value: "150+",
              label: "Projects Delivered",
            },
          ].map((item) => (
            <motion.div
              key={item.id}
              variants={fadeUp}
              className="flex flex-col items-center py-6 px-6"
            >
              {item.icon}
              <h3 className="text-3xl font-bold text-gray-900 mt-2">
                {item.value}
              </h3>
              <p className="text-gray-600 mt-1">{item.label}</p>
            </motion.div>
          ))}
        </motion.div>
      </section>
    </>
  );
};

export default ServicesSection;
